import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentsService } from '../providers/payments/payments.service';
import Swal from 'sweetalert2';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';

@Component({
  selector: 'app-unsubscription',
  templateUrl: './unsubscription.component.html',
  styleUrls: ['./unsubscription.component.scss']
})
export class UnsubscriptionComponent implements OnInit {
  subscriber_id:any;
  type:any;
  success:boolean = false;
  constructor(public route:ActivatedRoute,public router: Router, public paymentservice:PaymentsService, public location: Location) {
    this.subscriber_id = this.route.snapshot.paramMap.get('subscriberID');
    var _location = this.location.path();
    if(this.subscriber_id && _location.includes('cancel')){
      this.type = 'cancel';
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: "You want be Unsubscribe from Pixtar Service!",
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#878787",
      //   cancelButtonColor: "#d33",
      //   confirmButtonText: "Yes, Unsubscribe!"
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     this.cancelSubscription();
      //   }
      // });   
      this.cancelSubscription();   
    } else if(this.subscriber_id && _location.includes('pause')){
      this.type = 'pause';
      Swal.fire({
        title: "Are you sure?",
        text: "You want be Pause from Pixtar Service!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#878787",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Pause!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.pauseSubscription();
        }
      });      
    } else if(this.subscriber_id && _location.includes('resume')){
      this.type = 'resume';
      Swal.fire({
        title: "Are you sure?",
        text: "You want be Resume Pixtar Service!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#878787",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Resume!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.resumeSubscription();
        }
      });      
    }
   }

  ngOnInit(): void {

  }

  async cancelSubscription(){
    let obj = {};
    let reason_obj = {};
    const { value: reason } = await Swal.fire({
      title: "You want be Unsubscribe from Pixtar Service!",
      text: "Select reason for why are you cancelling,",
      input: "select",
      confirmButtonColor: "#878787",
      inputOptions: {
        customer_service: "Customer service was less than expected",
        low_quality: "Quality was less than expected",
        missing_features: "Some features are missing",
        other: "Other reason",
        switched_service: "I’m switching to a different service",
        too_complex: "Ease of use was less than expected",
        too_expensive: "It’s too expensive",
        unused: "I don’t use the service enough",
      },
      inputPlaceholder: "Select a Reason",
      // showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value) {
            resolve();
          } else {
            resolve("You need to select reason :)");
          }
        });
      }
    });
    if (reason) {
      reason_obj = reason; 
    }
		if(this.subscriber_id && reason){
      obj['subscriptionId'] = this.subscriber_id;
      obj['reason_obj'] = reason_obj;
			this.paymentservice.stripeSubscribeCancel(obj).subscribe(
				(response) => {
					if (response.body.code == 200) {
            this.success = true;
            Swal.fire({
              title: "Cancelled!",
              text: "Your Subscription has been Cancelled.",
              icon: "success",
              confirmButtonColor: "#878787",
            });
            // setTimeout(()=>{
            //   Swal.close()	
            //   this.router.navigate(['/']);
            // },5000);
					}	else {
            Swal.fire({
              title: "Error!",
              text: "Somethiing Error to Cancel your Subscription.",
              icon: "warning",
              confirmButtonColor: "#878787",
            });
					}
				},
			);
		}
	}

  pauseSubscription(){
		if(this.subscriber_id){
      let obj = {};
      obj['subscriptionId'] = this.subscriber_id;
			this.paymentservice.stripeSubscribePause(obj).subscribe(
				(response) => {
					if (response.body.code == 200) {
            this.success = true;
            Swal.fire({
              title: "Pause!",
              text: "Your Subscription has been Paused.",
              icon: "success",
              confirmButtonColor: "#878787",
            });
            // setTimeout(()=>{
            //   Swal.close()	
            //   this.router.navigate(['/']);
            // },5000);
					}	else {
            Swal.fire({
              title: "Error!",
              text: "Somethiing Error to Pause your Subscription.",
              icon: "warning",
              confirmButtonColor: "#878787",
            });
					}
				},
			);
		}
	}

  resumeSubscription(){
		if(this.subscriber_id){
      let obj = {};
      obj['subscriptionId'] = this.subscriber_id;
			this.paymentservice.stripeSubscribeResume(obj).subscribe(
				(response) => {
					if (response.body.code == 200) {
            this.success = true;
            Swal.fire({
              title: "Resume!",
              text: "Your Subscription has been Resume.",
              icon: "success",
              confirmButtonColor: "#878787",
            });
					}	else {
            Swal.fire({
              title: "Error!",
              text: "Somethiing Error to Resume your Subscription.",
              icon: "warning",
              confirmButtonColor: "#878787",
            });
					}
				},
			);
		}
	}

}
